import React, { useState } from "react";

const MS_LOGIN_URL = "/auth/external/ms";

const MicrosoftLogo = () => (
    <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1" width="9" height="9" fill="#F25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
        <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
        <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
);

const AuthRequired: React.FC = () => {
    const [hovering, setHovering] = useState(false);

    return (
        <div style={s.shell}>
            {/* ── Left: logo + brand ── */}
            <div style={s.left}>
                <img src="/logo.png" alt="Profase" width={72} height={72} style={s.logoImg} />
                <h1 style={s.brandName}>Profase CRM</h1>
            </div>

            <div style={s.divider} />

            {/* ── Right: login prompt ── */}
            <div style={s.right}>
                <p style={s.message}>
                    Inicia sesión con tu cuenta corporativa para acceder a la aplicación.
                </p>
                <a
                    href={MS_LOGIN_URL}
                    style={{ ...s.msButton, ...(hovering ? s.msButtonHover : {}) }}
                    onMouseEnter={() => setHovering(true)}
                    onMouseLeave={() => setHovering(false)}
                >
                    <MicrosoftLogo />
                    <span>Continuar con Microsoft</span>
                </a>
            </div>
        </div>
    );
};

const s: Record<string, React.CSSProperties> = {
    shell: {
        display: "flex",
        minHeight: "100vh",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(145deg, #0f172a 0%, #1e3a5f 60%, #0f172a 100%)",
        fontFamily: "'Inter','Segoe UI',system-ui,sans-serif",
        padding: 24,
    },

    /* Left panel */
    left: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        padding: "48px 52px",
        minWidth: 220,
    },
    logoImg: {
        borderRadius: 12,
    },
    brandName: {
        margin: 0,
        fontSize: 24,
        fontWeight: 800,
        color: "#f1f5f9",
        letterSpacing: "0.01em",
        whiteSpace: "nowrap",
    },

    /* Vertical separator */
    divider: {
        width: 1,
        alignSelf: "stretch",
        background: "rgba(255,255,255,0.15)",
        margin: "32px 0",
    },

    /* Right panel */
    right: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "center",
        gap: 24,
        padding: "48px 52px",
        maxWidth: 360,
    },
    message: {
        margin: 0,
        fontSize: 16,
        color: "#cbd5e1",
        lineHeight: 1.7,
    },

    /* Microsoft button */
    msButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 12,
        width: "100%",
        padding: "13px 20px",
        background: "#fff",
        border: "1.5px solid transparent",
        borderRadius: 8,
        fontSize: 15,
        fontWeight: 600,
        color: "#1e293b",
        cursor: "pointer",
        textDecoration: "none",
        boxSizing: "border-box",
        transition: "background 0.15s, box-shadow 0.15s, border-color 0.15s",
    },
    msButtonHover: {
        background: "#f1f5f9",
        borderColor: "#3b82f6",
        boxShadow: "0 0 0 3px rgba(59,130,246,0.2)",
    },
};

export default AuthRequired;
